import React, { useEffect, useState } from "react";

import Cookies from "js-cookie";
import { Row, Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";

import ContainerResponsive from "../../common/components/ContainerResponsive";
import PlanHeader from "../components/PlanHeader";
import PlanWeek from "../components/PlanWeek";
import { usePlan } from "../hooks/planHook";
import { PALETTE } from "../../common/ThemeConstants";
import { postRequest } from "../../api/axiosRequests";
import { useAuth } from "../../auth/hook";
import PlanBottomBar from "../components/PlanBottomBar";

export default function Plan() {
  const planContext = usePlan();
  const auth = useAuth();
  const [isLocked, setIsLocked] = useState(false);
  const [plan, setPlan] = useState({ id: -1, name: "no title", planWeeks: [] });
  const [buttonContent, setButtonContent] = useState("Acquista");

  const paddingBottom = isLocked ? 40 : 100;

  const nextPlanDay = () => {
    if (!plan || plan.id === -1) {
      return { id: -1, name: "no title", planWeeks: [] };
    }


    for (let i = 0; i < plan.planWeeks.length; i++) {
      const week = plan.planWeeks[i];
      for (let j = 0; j < week.planDays.length; j++) {
        const workout = week.planDays[j];
        if (!workout.done) {
          let next = { ...workout };
          next["nWeek"] = i;
          next["nDay"] = j;
          return next;
        }
      }
    }

    return { id: -1, name: "no title", planWeeks: [] };
  }

  const createSessionCheckout = (id) => {
    if (!auth.user.email || !auth.user.cf) {
      alert(
        "Completa il tuo profilo per procedere all'acquisto! Vai alle impostazioni e inserisci il Codice Fiscale."
      );
      return;
    }
    setButtonContent(
      <Spinner
        className="py-2 px-2"
        size="sm"
        color={PALETTE.SECONDARYCOLOR}
        animation="border"
      />
    );
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      "X-CSRFToken": csrftoken,
      Authorization: localStorage.getItem("jwt"),
    };
    const promise = postRequest(
      "createPlanCheckoutSession/",
      { idPlan: id },
      headers
    );
    promise
      .then((res) => {
        window.location.href = res.data.checkoutUrl;
      })
      .catch((errs) => {
        console.log(errs);
      });
  };

  useEffect(() => {
    // Scroll to the hash location
    if (window.location.hash) {
      const id = window.location.hash.substring(1); // Remove the # character

      // Retry mechanism for scrolling
      const attemptScroll = (attemptsLeft = 10, delay = 200) => {
        const element = document.getElementById(id);

        if (!element && attemptsLeft > 0) {
          // Element not found yet, retry after delay
          setTimeout(() => attemptScroll(attemptsLeft - 1, delay), delay);
          return;
        }

        // If element is still not found after retries, return
        if (!element) {
          return;
        }

        // Try different scroll methods with fallbacks
        const scrollSuccess = performScroll(element);

        // If scroll failed and we have attempts left, try again
        if (!scrollSuccess && attemptsLeft > 0) {
          console.log(`Scroll to #${id} failed, retrying... (${attemptsLeft} attempts left)`);
          setTimeout(() => attemptScroll(attemptsLeft - 1, delay), delay);
        }
      };

      // Try different scroll methods and return success status
      const performScroll = (element) => {
        try {

          // Check if element is in viewport already
          const rect = element.getBoundingClientRect();
          const isInViewport =
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth);

          // If the element is already in the viewport, no need to scroll
          if (isInViewport) {
            return true;
          }

          // First attempt with smooth scrolling
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return true;

        } catch (error) {
          // Smooth scroll failed, using fallback
          try {

            // Fallback for browsers that don't support smooth scrolling options
            element.scrollIntoView(true);
            return true;
          } catch (fallbackError) {

            // Fallback failed, using manual scroll
            try {
              // Manual scroll as last resort
              const rect = element.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const targetY = rect.top + scrollTop - (window.innerHeight / 2);

              window.scrollTo(0, targetY);
              return true;
            } catch (manualError) {
              // All scroll methods failed
              return false;
            }
          }
        }
      };

      // Start the retry process
      attemptScroll();
    }

    setIsLocked(planContext.planData.isLocked);
    setPlan(planContext.planData);
  }, [planContext.planData.isLocked, planContext.planData]);

  return (
    <div>
      <PlanHeader
        title={plan.name}
        image={plan.cover}
        showInfo={true}
        info={`Livello: ${plan.level} - Settimane: ${plan.weeks}`}
        showBackground={false}
        backTo={`/account/Workouts/${planContext.planData.category.name}`}
      />
      <ContainerResponsive>
        <Container style={{ paddingBottom: paddingBottom, paddingTop: 14 }}>
          {plan.planWeeks.length > 0 &&
            plan.planWeeks.map((week, idx) => (
              <Row key={idx} className="m-auto">
                <PlanWeek week={week} n_week={idx} isLocked={isLocked} />
              </Row>
            ))}
        </Container>
        {isLocked && (
          <>
            <div
              style={{
                position: "fixed",
                height: "115vh",
                width: "100%",
                top: "-15vh",
                textAlign: "center",
                backgroundColor: "#f5f5f5c2",
                zIndex: 100,
              }}
            />
            <div
              className="m-auto px-3"
              style={{
                width: "100%",
                bottom: 20,
                position: "fixed",
                zIndex: 101,
                backgroundColor: PALETTE.LIGHTGRAY,
              }}
            >
              <Container
                onClick={() => createSessionCheckout(planContext.planData.id)}
                className="rounded-md shadow p-1"
                style={{
                  cursor: "pointer",
                  textAlign: "center",
                  background: PALETTE.GRADIENT,
                  color: PALETTE.LIGHTGRAY,
                }}
              >
                <div
                  style={{
                    paddingTop: 15,
                    paddingBottom: 15,
                    borderRadius: 16,
                    color: PALETTE.WHITE,
                  }}
                >
                  <span>{buttonContent}</span>
                </div>
              </Container>
            </div>
          </>
        )}
      </ContainerResponsive>
      {(!isLocked && (<PlanBottomBar nextPlanDay={nextPlanDay} />))}
    </div>
  );
}
